const OFFICE_ONLINE_VIEWER =
  "https://view.officeapps.live.com/op/embed.aspx?src=";
const GOOGLE_DOCS_VIEWER = "https://docs.google.com/gview?embedded=1&url=";

// Office lidando com Office. Ponto.
const OFFICE_ONLINE_EXTENSIONS = ["ppt", "pptx", "doc", "docx", "xls", "xlsx"];

// Google fica só com o resto.
const GOOGLE_VIEWER_EXTENSIONS = ["pdf", "txt", "rtf", "odt", "odp", "ods"];

export function getFileExtension(url = "") {
  try {
    const parsedUrl = new URL(url);
    const path = parsedUrl.pathname || "";
    const extension = path.split(".").pop();
    return (extension || "").toLowerCase();
  } catch (error) {
    return "";
  }
}

export default function buildDocumentEmbedUrl(url = "") {
  if (!url) return "";

  const extension = getFileExtension(url);

  // Limpa o encode duplo decodificando a URL antes de aplicar o encodeURIComponent
  let safeUrl = url;
  try {
    safeUrl = decodeURIComponent(url);
  } catch (e) {
    // Se der erro no decode, segue com a original
  }

  const encodedUrl = encodeURIComponent(safeUrl);

  // Força o Office Viewer para arquivos da Microsoft independente do modo
  if (OFFICE_ONLINE_EXTENSIONS.includes(extension)) {
    return `${OFFICE_ONLINE_VIEWER}${encodedUrl}`;
  }

  if (GOOGLE_VIEWER_EXTENSIONS.includes(extension)) {
    return `${GOOGLE_DOCS_VIEWER}${encodedUrl}`;
  }

  return url;
}
